import { render, staticRenderFns } from "./applyJoin.vue?vue&type=template&id=6482f77d&scoped=true&"
import script from "./applyJoin.vue?vue&type=script&lang=js&"
export * from "./applyJoin.vue?vue&type=script&lang=js&"
import style0 from "./applyJoin.vue?vue&type=style&index=0&id=6482f77d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6482f77d",
  null
  
)

export default component.exports